if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.stickyWidget = this.querySelector('.product-form__buttons');
      this.footer = document.querySelector('footer.footer');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.optionsToggle = this.querySelector('.js-options-toggle');

      this.lookbookProductInfos = document.querySelectorAll('.lookbook-inner__slider .swiper-slide');

      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      window.addEventListener('scroll', this.updateFooterMargin.bind(this));
      window.addEventListener('load', this.updateFooterMargin.bind(this));
      window.addEventListener('resize', this.updateFooterMargin.bind(this));

      this.expandOptions();
    }

    expandOptions() {
      if (this.optionsToggle != null) {
        const textOpen = this.optionsToggle.dataset.open;
        const textClose = this.optionsToggle.dataset.close;

        this.optionsToggle.addEventListener('click', (event) => {
          event.preventDefault();

          const productItem = this.closest('.product-item--add');

          if (productItem != null) {
            const productVariants = productItem.querySelector('.product-item__variants');
            const productItemInfo = productItem.querySelector('.lookbook_product_info .product-item__info');
            const productSizes = productItem.querySelectorAll('.product-form__input--size .product-form__input-inner input');
            if (this.lookbookProductInfos) {
              this.lookbookProductInfos.forEach(function (lookbookProductInfo) {
                lookbookProductInfo.querySelector('.lookbook_product_info .product-item__info').classList.remove('open');
                lookbookProductInfo.querySelector('.lookbook_product_info .js-options-toggle').classList.remove('hidden');
                document.querySelector('body').classList.remove('overflow_hidden');
              });
            }

            if (productSizes.length > 1) {
              if (productVariants != null) {
                productVariants.classList.toggle('open');

                if (productItemInfo) {
                  productItemInfo.classList.add('open');

                  const mediaQuery = window.matchMedia('(max-width: 989px)');
                  if (mediaQuery.matches) {
                    this.optionsToggle.classList.remove('hidden');
                    document.querySelector('.lookbook-inner__slider .product_info_mobile.open .error_message').innerHTML = 'select size';
                  } else {
                    this.optionsToggle.classList.add('hidden');
                  }
                }

                if (productVariants.classList.contains('open')) {
                  this.optionsToggle.textContent = textOpen;
                } else {
                  this.optionsToggle.textContent = textClose;
                }
              }
            }
            else if (productSizes.length == 1) {
              const productSizeFirst = productItem.querySelector('.product-form__input--size .product-form__input-inner input');
              productSizeFirst.checked = true;

              if (this.closest('.product-item--add')) {
                setTimeout(() => {
                  // triggering add to cart button
                  this.triggerSingleVariantAddToCart();
                }, 1000);
              };
            }
          };
        });
      };
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      // this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const productElements = this.querySelectorAll('.product-entry');
      const products = [];

      for (const productElement of productElements) {
        const id = productElement.querySelector('[name=id]').value;
        let quantity = 1;
        let properties = {};

        if (productElement.querySelector('[data-cart-quantity]')) {
          quantity = parseInt(productElement.querySelector('[data-cart-quantity]').value, 10);
        }

        // Get properties if available
        const propertyInputs = productElement.querySelectorAll('.property');
        for (const propertyInput of propertyInputs) {
          const propName = propertyInput.dataset.propertyName;
          const propValue = propertyInput.value;
          properties[propName] = propValue;
        }

        products.push({
          id,
          quantity: quantity || 0,
          properties: properties,
        });
      }

      await Promise.all(products.map(product => window.theme.addToCart(product)))
        .then((results) => {
          let hasError = false;
          for (const result of results) {
            if (result.error) {
              this.handleErrorMessage(result.error);
              hasError = true;
              break;
            }
          }
          //check if no error found then close the mini cart quick view on submit
          if (results.some(item => !item.error)) {
            const closeBtn = document.querySelector(".mini-cart-close-icon");
            if (closeBtn) {
              closeBtn.click();
            };
          }

          if (!hasError) {
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              quickAddModal.hide(true);
            }
          }
        })
        .finally(() => {
          if(this.submitButton.closest('.modal-addons')){
            this.submitButton.classList.remove('loading');
            this.submitButton.classList.add('checkmark');
          }else{
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      let parentElem = this.closest('product-info');
      let sizesElem = parentElem.querySelector('variant-radios fieldset.product-form__input--size');

      function isElementInViewport(el) {
        const rect = el.getBoundingClientRect();
        return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
      }

      if (errorMessage) {
        if (errorMessage == "Invalid item ID") {
          parentElem.classList.remove('variantIsSelected');
          this.errorMessage.textContent = 'Please select a size';
          if(!sizesElem) return
          sizesElem.classList.add('selectInputOption');
          const elementPosition = sizesElem.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.scrollY - 100;
          if(!isElementInViewport(sizesElem)) {
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        } else {
          parentElem.classList.add('variantIsSelected');
          this.errorMessage.textContent = errorMessage;
        }
      } else {
        parentElem.classList.add('variantIsSelected');
        sizesElem?.classList.remove('selectInputOption');
      }
    }

    calculateStickyWidget() {
      if (this.stickyWidget != null) {
        return this.stickyWidget.offsetHeight;
      }
      return 0;
    }

    updateFooterMargin() {
      requestAnimationFrame(() => {
        const currentWidgetHeight = this.calculateStickyWidget();

        this.footer.style.marginBottom = `${currentWidgetHeight}px`;
      });
    }

    triggerSingleVariantAddToCart() {
      const addToCartButton = this.closest(".product-item--add").querySelector('button[name="add"]');
      if (addToCartButton != null) {
        setTimeout(function () {
          addToCartButton.click();
        }, 10);
      }
    }
  });

}
